module.exports = __webpack_public_path__ + "static/media/cards-team-front-4.4da1f603.webp";